import React from "react";
import { formatNumber } from "@globals/format";
import { t } from "@client/lib/dictionary";
import type { BmsRecord } from "@client/types/bms";
import { Card, CardContent, CardHeader, CardTitle } from "@client/components/ui/card";

interface Props {
  record: BmsRecord;
}

const Row: React.FC<{ label: string; value: string | number | undefined }> = ({ label, value }) => (
  <div className="flex justify-between gap-4 text-sm py-1 border-b border-border last:border-0">
    <span className="text-muted-foreground">{label}</span>
    <span className="font-mono">{value ?? "—"}</span>
  </div>
);

/**
 * Karta s metadata o BMS — pouze pole, která reálně máme (z DB).
 * HW/SW version, Vendor ID, Serial, Production date, Manufacturer LEGACY
 * protokol nedokumentuje, takže je v UI neukazujeme.
 */
export const BmsDeviceInfo: React.FC<Props> = ({ record }) => (
  <Card>
    <CardHeader>
      <CardTitle>{t.bms.deviceInfo}</CardTitle>
    </CardHeader>
    <CardContent>
      <Row label={t.bms.fields.name} value={record.name} />
      <Row label={t.bms.fields.slug} value={record.slug} />
      <Row label={t.bms.fields.transport} value={`${record.transportType} · ${record.transportTarget}`} />
      <Row label={t.bms.cellCount} value={record.cellCount} />
      <Row
        label={t.bms.fields.capacity}
        value={record.capacityMah ? `${formatNumber(record.capacityMah)} mAh` : "—"}
      />
      <Row label={t.bms.fields.chemistry} value={record.chemistry} />
    </CardContent>
  </Card>
);
